import refreshRecordBuilder from "quickfire/integration/builders/record/refresh-record-builder";
import spinRecordBuilder from "quickfire/integration/builders/record/spin-record-builder";
import Gameplay from "slotworks/model/gameplay/gameplay";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import { RecordBuilder } from "slotworks/server/builders/record-builder";

export class RecoveryRecordBuilder implements RecordBuilder {
    public filter(request: any, packet: QuickfireResponsePacket): boolean {
        let isRecovery = false;

        if (request instanceof AuthRequestPayload) {
            isRecovery = parseInt(packet.Response.Slot.attributes.freeSpinTotalAwarded) > 0;
        }

        return isRecovery;
    }

    public build(gameplay: Gameplay, request: any, packet: QuickfireResponsePacket) {
        gameplay.isRecovered = true;

        refreshRecordBuilder.build(gameplay, request, packet);

        let records = this.buildLastRecord(gameplay, request, packet);

        if (records[0] instanceof FreespinRecord) {
            const rebuiltRecords = this.rebuildFreespinRecords(records[0], gameplay, request, packet);
            records = rebuiltRecords.concat(records);
        }

        gameplay.startBalance = gameplay.balance;

        return records;
    }

    protected buildLastRecord(gameplay: Gameplay, request: any, packet: QuickfireResponsePacket): SpinRecord[] {
        return spinRecordBuilder.build(gameplay, request, packet);
    }

    protected rebuildFreespinRecords(currentFreespin: SpinRecord, gameplay: Gameplay, request: any, packet: QuickfireResponsePacket): SpinRecord[] {
        const records = [];

        // Force stage to base game so triggering record can be parsed
        packet.Response.Slot.attributes.stage = "basegame";

        // Create a dummy triggering spin record
        const triggerRecord = this.createTriggerRecord(gameplay, request, packet);
        triggerRecord.hasChildren = true;
        triggerRecord.lastChild = false;
        triggerRecord.cashWon = 0;

        const currentFreespinWin: FreespinWinResult = (currentFreespin.getResultsOfType<FreespinWinResult>(FreespinWinResult))[0];
        let freespinsTriggeredThisSpin: number = 0;
        if (currentFreespinWin) {
            freespinsTriggeredThisSpin = currentFreespinWin.freespinsWon;
        }

        const totalFreespinsWon: number = parseInt(packet.Response.Slot.attributes.freeSpinTotalAwarded);
        const freespinsRemaining: number = parseInt(packet.Response.Slot.attributes.freeSpins);
        const freepinsPlayed: number = totalFreespinsWon - freespinsRemaining;

        // Create dummy freespin trigger win on trigger record
        const dummyFreespinWin = new FreespinWinResult();
        dummyFreespinWin.freespinsWon = totalFreespinsWon - freespinsTriggeredThisSpin;
        triggerRecord.results = [dummyFreespinWin];

        // Account for wins prior to the current result
        let unaccountedWins = parseInt(packet.Response.Slot.attributes.freeSpinTotalWin) - currentFreespin.cashWon;

        // Populate in empty freespins to represent seen spins
        for (let i = 1; i < freepinsPlayed; i++) {
            const previousFreespinRecord = new FreespinRecord();
            previousFreespinRecord.cashWon = unaccountedWins;
            unaccountedWins = 0;
            records.unshift(previousFreespinRecord);
        }

        // Add triggering record as first record
        records.unshift(triggerRecord);

        return records;
    }

    protected createTriggerRecord(gameplay: Gameplay, request: any, packet: QuickfireResponsePacket): SpinRecord {
        return spinRecordBuilder.build(gameplay, request, packet)[0];
    }
}

export default new RecoveryRecordBuilder();
